module.exports = __webpack_public_path__ + "static/img/image-selling-cars-process_dark.392b9728.png";